import { Component, OnInit,OnDestroy } from '@angular/core';
import { UserService } from '../../../auth/services/user.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { User } from '../../../auth/models/user.model';
import { ReclamationService } from '../../services/reclamation.service';
import { Reclamation } from '../../models/reclamation';
import { CommunService } from '../../../../shared/services/commun';
import Swal from 'sweetalert2';
import { TokenStorageService } from '../../../auth/services/token-storage.service';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
@Component({
  selector: 'app-detailrec',
  templateUrl: './detailrec.component.html',
  styleUrls: ['./detailrec.component.scss']
})
export class DetailrecComponent implements OnInit,OnDestroy {
  public reclamation: Reclamation;
  public imagePreview: string;
  fileUploaded = false; 
  public loading = false;
  errormsg:string;
  submitted=false
  user: User;
  informations=[]
  usertype: string;
  users: User[]=[];
  filtredusers: any[]=[];
  prenom: any;
  nom: any;
  raisonsociale: any;
  nature: any;
  usersSub: Subscription;
  public showphase=false
  public showall=false
  effectiveuser: User;
  currentuser: any;
  shownotifbox: boolean =false;
  selectedaction: any='';
  isButtonDisabled: any=false;
  uploadedfiles: any[]=[];
  showform: boolean=false;
  reclamationform: FormGroup;
  selectedtime: number;
  constructor( private formBuilder: FormBuilder,private route: ActivatedRoute, private router: Router,private recserv: ReclamationService, private userservice:UserService,private token: TokenStorageService,private commun: CommunService) {}
  returntospecificboard()
  {
    //@ts-ignore
    if(this.reclamation.transactions[0].ISSUERBANKIDENTIFICATION==this.reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION)
    {
      this.router.navigateByUrl('/dashboard/user-board/onus')
    }
    //@ts-ignore
    else   if(this.reclamation.transactions[0].ISSUERBANKIDENTIFICATION==this.user.banque)
    {
      this.router.navigateByUrl('/dashboard/user-board/eme')
    }
    //@ts-ignore
    else   if(this.reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION==this.user.banque)
    {
      this.router.navigateByUrl('/dashboard/user-board/acq')
    }
  }
  ngOnInit() {
    this.currentuser = this.token.getUser();
    this.reclamationform = this.formBuilder.group({                
      commentaire:'',
      motif: '',
      groupe: '',
      famille: '',
      file: '',
    });  
  this.userservice.getUserById(this.currentuser.userId).then(
    (user: User) => {
      this.user=user
    }
  )
  this.loading = true;
  this.route.params.subscribe(
    (params) => {
      this.recserv.getReclamationdataById(params.id).then(
        (reclamation: Reclamation) => {
          this.reclamation = reclamation;
          this.userservice.getUserById(reclamation.userId).then(
            (user: User) => {
if(user)
{
  this.loading = false;
  this.usertype=user.usertype
  this.nature=user.nature
  this.prenom=user.firstname
  this.nom=user.lastname
  this.raisonsociale=user.raisonsociale
  this.effectiveuser=user
}  


              //@ts-ignore
    params.date!='all'?
              //@ts-ignore
    (this.informations=reclamation.statut.filter(e=>e.date==params.date),this.showphase=true):
    (this.informations=reclamation.statut,this.showall=true,this.shownotifbox=true)
                /*this.statutssub = this.recserv.changements$.subscribe(
                  (changements) => {
                    this.reclamation.changements = changements;
          
                  }
                )*/
            }
          )
              
        }
      );
    }
  );
  }
  get f() { return this.reclamationform.controls; }
  getNavigation(link){
    this.router.navigate([link]); 
  }
  filteracteur(value:string):string
{
  let view:string
  value=='Clientpor'?view='Client Porteur':
  value=='Clientcomm'?view='Client Commerçant':
  value=='Metier'?view='Métier':
  value=='Agence'?view='Agence':
  value=='comite arbitrage'?view='Comité arbitrage':''
  return view
}
showtopic(): boolean {
  // @ts-ignore
  let actualstatut = this.reclamation.statut.filter(e=>!e.etat)[this.reclamation.statut.length - 1].item;
  let currenttype = this.user.usertype;
  // @ts-ignore
  let iss=this.reclamation.transactions[0].ISSUERBANKIDENTIFICATION
    // @ts-ignore
  let acq=this.reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION
let currentcodebanque=this.user.banque
  const statutValides = ['crée', 'rechdoc'];
  const typesValides = ['Clientpor', 'Agence'];

  if (statutValides.includes(actualstatut) && iss==currentcodebanque ||typesValides.includes(currenttype)||iss==acq) 
  {
    return true; // Montrer le sujet si les conditions sont remplies
  }

  return false; // Ne pas montrer le sujet par défaut
}
showrecapmotif(): boolean {
  // @ts-ignore
  let currenttype = this.user.usertype;
  const typesValides = ['Metier', 'comite arbitrage'];

  if (typesValides.includes(currenttype)) 
  {
    return true; // Montrer le sujet si les conditions sont remplies
  }

  return false; // Ne pas montrer le sujet par défaut
}
/*filtredstatut(rec:Reclamation):any
{
  let filtredstatut
  //@ts-ignore
  filtredstatut=rec.statut.filter(e=>!e.etat)
  return filtredstatut
}*/
filterstat(dureestatut:any):boolean
{
//@ts-ignore
  let acqcode= this.reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION
  //@ts-ignore
  let isscode= this.reclamation.transactions[0].ISSUERBANKIDENTIFICATION
//@ts-ignore
  if(this.reclamation.statut.find(e=>e.date==dureestatut&&e.role!='batch'))
  {
    //afficher les statuts pour emetteur
    if(this.user.usertype=='Metier'&&this.user.banque==isscode&&this.user.banque!=acqcode)
    {
      //@ts-ignore
      console.log(this.reclamation.statut.find(e=>e.date==dureestatut))

   //@ts-ignore
   if(this.reclamation.statut.find(e=>e.date==dureestatut&&e.etat=='notification commerçant'
      //@ts-ignore
   ||e.date==dureestatut&&e.etat=='réponse'
      //@ts-ignore
   ||e.date==dureestatut&&e.role=='usercomite'
         //@ts-ignore
   ||e.date==dureestatut&&e.etat&&e.role=='admincomite'
         //@ts-ignore
   ||e.date==dureestatut&&e.role=='acquireur'&&e.etat)) 
   {
     return false
   } 
   else
   {
     return true
   }   
    }

  //afficher les statuts pour acquireur
 else if(this.user.usertype=='Metier'&&this.user.banque!=isscode&&this.user.banque==acqcode)
  {
  //@ts-ignore
  if(this.reclamation.statut.find(e=>e.date==dureestatut&&e.role=='acquireur'
    //@ts-ignore
  ||e.date==dureestatut&&e.role=='émetteur'&&!e.etat&&e.item!='crée'&&e.item!='rejetée'
    //@ts-ignore
  ||e.date==dureestatut&&e.etat=='notification commerçant'
     //@ts-ignore
  ||e.date==dureestatut&&e.etat=='réponse commerçant'
  //@ts-ignore
  ||e.date==dureestatut&&!e.etat&&e.role=='admincomite'
))
  {
    return true
  }
  else
  {
    return false
  }
  }
    //afficher les statuts pour porteur
   else if(this.user.usertype=='Clientpor')
    {
      let effectiverole='émetteur'
     //@ts-ignore
     if(this.reclamation.statut.find(e=>e.date==dureestatut&&e.acteur==this.user.usertype||e.date==dureestatut&&e.role==effectiverole&&e.item!='chb émis'&&e.item!='pré-arbitrage'&&e.item!='arbitrage'&&!e.etat||e.date==dureestatut&&this.reclamation.transactions[0].ISSUERBANKIDENTIFICATION==this.reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION&&!e.etat))
     {
        return true
      }
      else
      {
        return false
      }
    }
  //afficher les statuts pour commerçant
    else  if(this.user.usertype=='Clientcomm')
    {
      let effectiverole='acquireur'
     //@ts-ignore
     if(this.reclamation.statut.find(e=>e.date==dureestatut&&e.acteur==this.user.usertype||e.date==dureestatut&&e.role==effectiverole&&e.item!='rejetée'&&e.item!='pré-arbitrage rejetée'&&e.item!='arbitrage rejeté'||e.date==dureestatut&&this.reclamation.transactions[0].ISSUERBANKIDENTIFICATION==this.reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION&&e.etat))
     {
        return true
      }
      else
      {
        return false
      }
    }
    //afficher statut pour arbitrage
    else  if(this.user.usertype=='comite arbitrage')
    {
     //@ts-ignore
      if(this.reclamation.statut.find(e=>e.date==dureestatut&&e.acteur==this.user.usertype
        //@ts-ignore
        ||e.date==dureestatut&&e.item!='crée'&&e.item!='relancée'
        //@ts-ignore
      ||e.date==dureestatut&&e.item=='rejetée'&&e.role!='émetteur'
        //@ts-ignore
      ||e.date==dureestatut&&e.etat!='notifier commercant'
          //@ts-ignore
          ||e.date==dureestatut&&e.etat!='réponse commercant'
          ))
      {
        return true
      }
      else
      {
        return false
      }
    }
  else 
  {
    return false
  }
  }
  else
  {
    return false
  }
}
/*filterstatcommport(dureestatut:any):boolean
{
  if(this.user.usertype=='Clientpor')
  {
    let effectiverole='émetteur'
   //@ts-ignore
    if(this.reclamation.statut.find(e=>e.date==dureestatut&&e.acteur==this.user.usertype||e.date==dureestatut&&e.role==effectiverole&&e.item!='chb émis'&&e.item!='pré-arbitrage'&&e.item!='arbitrage'||e.date==dureestatut&&this.reclamation.transactions[0].ISSUERBANKIDENTIFICATION==this.reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION))
    {
      return true
    }
    else
    {
      return false
    }
  }
  else  if(this.user.usertype=='Clientcomm')
  {
    let effectiverole='acquireur'
   //@ts-ignore
   if(this.reclamation.statut.find(e=>e.date==dureestatut&&e.acteur==this.user.usertype||e.date==dureestatut&&e.role==effectiverole&&e.item!='rejetée'&&e.item!='pré-arbitrage rejetée'&&e.item!='arbitrage rejeté'||e.date==dureestatut&&this.reclamation.transactions[0].ISSUERBANKIDENTIFICATION==this.reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION&&e.etat))
   {
      return true
    }
    else
    {
      return false
    }
  }
else 
{
  return false
}
}
filterarbitrage(dureestatut:any):boolean
{
  if(this.user.usertype=='comite arbitrage')
  {
    let effectiverole='émetteur'
   //@ts-ignore
    if(this.reclamation.statut.find(e=>e.date==dureestatut&&e.acteur==this.user.usertype||e.date==dureestatut&&!e.etat&&e.item!='crée'&&e.item!='rejetée'&&e.item!='encours'&&e.acteur!='Clientpor'
      //@ts-ignore
    ||e.date==dureestatut&&e.item=='rejetée'&&e.role!='émetteur'))
    {
      return true
    }
    else
    {
      return false
    }
  }
}*/
filtervalue(value:string):string
{
  let view:string
  value=='T'?view='TPE/ECOM':
  value=='G'?view='GAB':
  value==''||value=='O'||value=='M'?view='Manual':
  value=='R'?view='Recharge GAB':
  value=='Z'?view='Mobile':
  value=='05'?view='Achat':
  value=='06'?view='crédit':
  value=='07'?view='Cash Advance':
  value=='08'?view='Retrait':
  value=='15'?view='Impayé GAB':
  value=='17'?view='Impayé CASH ADVANCE':
  value=='18'?view='Impayé GAB':
  value=='1'?view='1st CHARGEBACK':
  value=='2'?view='2nd CHARGEBACK':
  value
  return view
}
filtermotif():string
{
  let returned:string
  let returned2:string
  let returned3:string

  //@ts-ignore
  let mot=this.reclamation.statut.find(e=>e.motif)
    //@ts-ignore
    mot?(returned=mot.motif,returned2=mot.famille,returned3=mot.groupe):returned=null
    //@ts-ignore
  return [returned,returned2,returned3]
}
opendetail(link, id,date){
      
  this.router.navigate([]).then((_result) => {
    window.open(link + '/' + id+ '/' + date, '_blank');
  });; 
}
changeaction(e)
{
 // this.showvalidationbutton=true
 this.showform=true
  this.selectedaction = e.target.value
 // this.selectedaction=='chb émis'?this.showmotif=true:this.showmotif=false
//this.selectedaction=='notification'?(this.commvalue=true,this.showform=true):(this.commvalue=false,this.showform=false)
}
onSend(user: User) {
  if (this.isButtonDisabled) {
    return; // Prevent multiple submissions
  }
  this.commun.getcurrenttime().then(async (time: any) => {
    this.selectedtime=time
    this.recserv.getReclamationdataById(this.reclamation._id).then(async (reclamation: Reclamation) => {
              //@ts-ignore
  let effectivestatus= reclamation.statut.filter(e=>!e.etat)
      this.loading = true;
      this.submitted = true;
      this.isButtonDisabled = true; // Disable the button when clicked
      reclamation.statut = this.reclamation.statut;
  //@ts-ignore
  reclamation.statut.push({
    //@ts-ignore
item: effectivestatus[effectivestatus.length-1].item,
    //@ts-ignore
date: time,
//@ts-ignore
etat:this.selectedaction=='notification'?'Ajout note':this.selectedaction=='notifiercommercant'?'notification commerçant':'réponse commerçant',
//@ts-ignore
acteur:this.user.usertype,
//@ts-ignore
role:reclamation.transactions[0].ISSUERBANKIDENTIFICATION==this.user.banque&&this.user.usertype!='comite arbitrage'?'émetteur':
//@ts-ignore
reclamation.transactions[0].ACQUIRERBANKIDENTIFICATION==this.user.banque&&this.user.usertype!='comite arbitrage'?'acquireur':
 //@ts-ignore
 this.user.role=='usercomite'?'usercomite':
 //@ts-ignore
 this.user.role=='admincomite'?'admincomite':
 'autre',
//@ts-ignore
commentaire :this.reclamationform.get('commentaire').value,
//@ts-ignore
motif :'',
//@ts-ignore
famille :'',
//@ts-ignore
groupe :'',
//@ts-ignore
identity :this.user.firstname+''+this.user.lastname,
//@ts-ignore
ficheUrl : []
})
      await this.recserv.modify(reclamation._id, reclamation, this.uploadedfiles).then(
        (data:any) => {
      
       //   this.getNavigation('open-detail/'+reclamation._id+'/all');
        },
        (error) => {
        } 
      );
          // Show success message
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'réclamation(s) traitée(s) avec succès!',
            showConfirmButton: false,
            timer: 6000
          }).then(
            () => {
              window.location.reload()
            }
          );
    }).catch(error => {
      console.error('Error fetching reclamation data:', error);
      this.loading = false;
    });
  }).catch(error => {
    console.error('Error fetching current time:', error);
    this.loading = false;
  });
}

ngOnDestroy() {
  this.usersSub?this.usersSub.unsubscribe():''
}
}

